import { getInstanceSpaceSlug } from '@shared/all/domains/spaces';
import { usePathname } from 'next/navigation';

import { spaceConfig } from '../utils/getSpaceConfig';

// The space this page is standing in, if any. Mobile's twin is the
// `instanceSpaceSlug` constant in its `utils/getSpaceConfig`.
export const useInstanceSpaceSlug = () =>
  getInstanceSpaceSlug(spaceConfig, usePathname());
